import React from "react";

import "./textField.css";
import TextFieldWrapper from "./textFieldWrapper";

interface TextAreaProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    maxLength?: number;
}

export default function TextArea(props: TextAreaProps) {

    var value = props.value;
    if(value == null) value = "";

    return <TextFieldWrapper info={props.maxLength ? value.length + "/" + props.maxLength : undefined} className={props.className} label={props.label}>
        <textarea
            value={value}
            onChange={(e) => {
                if(props.maxLength && e.target.value.length > props.maxLength) return;
                props.onChange(e.target.value)
            }}
            placeholder={props.placeholder}
        />
    </TextFieldWrapper>;
}